import { AuthService } from '../auth.service';

import { Component, inject, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-auth-automatic-code',
  template: 'Automatic Login - {{ signInIsRunning() }} {{ errorMessage() }}',
})
export class AuthAutomaticCodeComponent implements OnInit {
  private auth = inject(AuthService);
  public router = inject(Router);
  public signInIsRunning = signal(false);

  errorMessage = signal<string>(undefined);

  ngOnInit(): void {
    if (!this.signInIsRunning()) {
      this.login();
    }
  }

  async login() {
    const code = this.extractCodeFromUrl();
    if (!code) {
      this.errorMessage.set('Kein Code in der URL gefunden.');
      return;
    }

    this.signInIsRunning.set(true);
    this.auth
      .automaticCredentialsByCode(code)
      .then(user => {
        this.signInIsRunning.set(false);
        // handleAuthentication navigates to '/' itself, but only once
        // customerDocument/userProfile are loaded - an extra navigate here
        // would render the navbar prematurely with an empty customerDocument.
        this.auth.handleAuthentication(user, true);
      })
      .catch(error => {
        this.signInIsRunning.set(false);
        this.errorMessage.set('Automatische Anmeldung fehlgeschlagen.');
        console.error('AuthAutomaticCodeComponent login error', error);
      });
  }

  // The code is passed as a bare string after the question mark, e.g.
  // /automatic-login?<code>. Angular's router treats it as a query param with
  // no value and normalizes the address bar to "?<code>=", so the trailing
  // "=" has to be stripped off here too.
  private extractCodeFromUrl(): string | null {
    const rawQuery = window.location.search.slice(1);
    if (!rawQuery) {
      return null;
    }
    const code = rawQuery.split('&')[0].split('=')[0];
    return code ? decodeURIComponent(code) : null;
  }
}
